<template>
<div>
   <div class="title">
    <span class="link">需求管理 ></span> <span class="curLink">我参与的</span>
   </div>
   <div class="content">
     <div class="pageList">
         <div class="list">
           <template v-if="content.length">
             <div class="listItem" v-for="(item, index) in content" :key="index">
                  <div class="pageTitle">
                  <img :src="item.userLogo ? baseUrl + item.userLogo : require('../../assets/images/-s-mrtx.png')" width="30px" height="30px">
                  <span class="name">{{item.username}}</span>
                  <span class="time">{{item.discussTime}}</span>
                  </div>
                  <div class="pageContent">
                  <div>
                      <div class="typeName">{{item.name}}</div>
                      <div class="infoContent">最近 {{item.viewNum}} 人看过 · {{item.discussNum}} 回答</div>
                  </div>
                  <div class="btn" @click="goDetail(item.demandId)">
                      <div>查看详情</div>
                      <img src="../../assets/images/rightArrow.png" target="_blank" alt="">
                  </div>
                  </div>
                  <!--新加的评论 start-->
                    <div class="commentlist">
                      <div class="clearfix">
                        <div class="lookBtn" @click="handleLook(index, item.flag)">
                          <img src="../../assets/images/icon_pl@2x.png" />
                          <span>
                            <template v-if="item.flag">收起评论</template>
                            <template v-else>查看评论 <span class="plNum">{{item.msgVo.length}}</span></template>
                          </span>
                        </div>
                      </div>
                      <div class="commentBox" v-show="item.flag">
                        <template v-if="item.msgVo.length">
                          <div class="commentItem" v-for="(cItem, cIndex) in item.msgVo" :key="cIndex">
                              <div>
                                <img :src="item.userLogo ? baseUrl + item.userLogo : require('../../assets/images/-s-mrtx.png')" class="avatar" /><span class="nickName">{{item.username}}</span>
                                <span class="commTime">{{cItem.discussTime}}</span>
                              </div>
                              <div class="plText">
                                <span>评论：</span>
                                {{ cItem.message}}
                              </div>
                          </div>
                        </template>
                        <div v-else class="noData">暂无数据
                          <!-- ，快去<span @click="goDetail(item.id)">评论</span>吧！ -->
                        </div>
                      </div>
                    </div>
                  <!--新加的评论 end-->
              </div>
           </template>
            <template v-else>
              <Nodata />
            </template>
         </div>


         <div class="pageBox">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
     </div>
   </div>
</div>
</template>
<script>
  import {
    UserParticipateList
  } from '@/api/api'
  import Paging from "@/components/common/commonTable";
  import Nodata from '@/components/noData.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  export default {
    data() {
      return {
        pageNum: 0,
        pageSize: 10,
        loading: false,
        total: 0,
        content: [],
        baseUrl: serverUrl.baseURL,
      }
    },
    components: {
      Paging,
      Nodata
    },
    mounted() {
      this.getUserParticipateList()
    },
    methods: {
      goDetail(id) {
        let routeUrl = this.$router.resolve({
          path: "/DiscussDetails",
          query: {data: id}
        });
        window.open(routeUrl.href, '_blank');
      },
      // 评论
      handleLook(index, flag) {
        this.content[index].flag = !flag
      },
      //当前页变更
      handleCurrentChange(num) {
        this.pageNum = num
        this.getUserParticipateList();
      },
      //当前页查询数据条数变更
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.currentPage = 1;
        this.getUserParticipateList();
      },
      getUserParticipateList() {
        let params = {
          page: this.pageNum >= 1 ? this.pageNum - 1 : this.pageNum,
          size: this.pageSize
        }
        UserParticipateList(params).then(res=> {
          this.content = res.data.content.map(item => {
            return {
              ...item,
              flag: false
            }
          })
          this.total = Number(res.data.totalElements)
        })
      },
    }
  }
</script>
<style scoped>
.title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }
  .curLink{
    cursor: pointer;
  }
  .link{
    color: rgba(144, 157, 177, 1);
  }
  .content {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .pageList {
    width: 100%;
    height: calc(100vh - 180px);
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 40px;
  }
  .list{
    height: calc(100vh - 280px);
    overflow-y: scroll;
  }
  .list::-webkit-scrollbar { width: 0 !important }
  .pageBox{
    display: flex;
    justify-content: flex-end;
  }
  .listItem {
    border-bottom: 1px solid #E8EBF4;
    padding: 20px 0;
  }
  .pageTitle {
    display: flex;
    align-items: center;
    padding: 10px 0;
  }
  .pageContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pageContent > div > div {
    padding: 10px 0;
  }

  .btn {
    width: 135px;
    height: 43px;
    border: 1px solid #0F5EFF;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

  }
  .btn > img {
    margin-top: 3px;
    margin-left: 5px;
    /* width: 18px;
    height: 9px; */
  }

  .btn > div {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    text-align: center;
    /* line-height: 43px; */
  }

  .name {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    line-height: 21px;
    margin: 0 20px;
  }

  .time {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #516381;
    line-height: 28px;
  }

  .typeName {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
  }

  .infoContent {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #516381;
    line-height: 28px;
  }

  .oneRow {
    display: flex;
    justify-content: flex-start;
  }

  .oneRow > div {
    width: 30%;
  }


  .commentlist .commentBox{
    border-top: 1px solid #9DB8EF;
    background: #F4F5F9;
    padding-top: 25px;
    max-height: 556px;
    overflow-y: scroll;
  }
  .commentItem{
    padding: 0 23px 30px;
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
  }
  .commentItem .avatar{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 13px;
  }
  .commentItem .nickName{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
  }
  .plText{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    padding-top: 20px;
  }
  .plText span {
    color: #225EFD;
  }
  .lookBtn{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #0F5EFF;
    border-radius: 21px;
    display: inline-block;
    padding: 5px 10px;
    float: right;
    margin-bottom: 10px;
  }
  .lookBtn img {
    width: 18px;
    height: 18px;
    display: inline-block;
    position: relative;
    top: 2px;
  }
  .commTime{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #516381;
    float: right;
  }
  .clearfix::after {
    content: "";
    display: block;
    visibility: hidden;
    clear: both;
  }

.noData{
  text-align: center;
  padding: 50px 0;
}
.noData span{
  color: #0F5EFF;
  cursor: pointer;
}
.plNum{
  color: #0F5EFF;
}

</style>



// WEBPACK FOOTER //
// src/views/console/MyJoin.vue